/**
 * Site-wide cinematic nightclub atmosphere.
 * Layers (back → front):
 *   1. Drifting blurred light orbs (gold / emerald / amber / teal)
 *   2. Slow diagonal light beams sweeping across the room
 *   3. Bottom stage-light wash (warm amber)
 *   4. Bokeh dots — soft out-of-focus club lights
 *   5. Film grain
 *   6. Cinematic vignette
 * Mounted once at the root of <App /> and pinned with `pointer-events-none`.
 */
export default function AmbientBackground() {
    return (
        <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none" aria-hidden="true">
            <div className="ambient-base" />
            <div className="ambient-orb ambient-orb-gold" />
            <div className="ambient-orb ambient-orb-emerald" />
            <div className="ambient-orb ambient-orb-amber" />
            <div className="ambient-orb ambient-orb-teal" />
            <div className="ambient-beam ambient-beam-1" />
            <div className="ambient-beam ambient-beam-2" />
            <div className="ambient-bokeh" />
            <div className="ambient-stage" />
            <div className="ambient-grain" />
            <div className="ambient-vignette" />
        </div>
    );
}
